import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  getAuth,
  setPersistence
} from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { firebaseEnv, functionsRegion, validateEnvironment } from "../config/env";

export const firebaseMissingKeys = validateEnvironment();
export const firebaseReady = firebaseMissingKeys.length === 0;

export const firebaseApp = initializeApp(firebaseReady ? firebaseEnv : {
  apiKey: "demo",
  authDomain: "demo.invalid",
  projectId: "mundely-demo",
  storageBucket: "mundely-demo.invalid",
  messagingSenderId: "0",
  appId: "demo"
});

export const auth = getAuth(firebaseApp);
void setPersistence(auth, browserLocalPersistence).catch(() => undefined);

export const db = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export const storage = getStorage(firebaseApp);
export const functions = getFunctions(firebaseApp, functionsRegion);
